<template>
    <div :class="filterVisible()">
        <div>
            <template v-if="$store.state.currentFilters && Object.keys($store.state.currentFilters).length > 0">
                <plugin-filter
                        v-for="filter in $store.state.currentFilters"
                        :title="filter.label"
                        :entries="filter.entries"
                        :value="filter.value"
                        :key="filter.label"
                        @toggle-filter="toggleFilter"></plugin-filter>
                <template v-if="false">
                    <plugin-filter
                        :title="$store.state.rating.label"
                        :entries="$store.state.rating.entries"
                        :value="$store.state.rating.value"
                        :layout="'rating'"
                        @toggle-filter="toggleFilter"></plugin-filter>
                    <plugin-filter
                        :title="$store.state.downloads.label"
                        :entries="$store.state.downloads.entries"
                        :value="$store.state.downloads.value"
                        :layout="'downloads'"
                        @toggle-filter="toggleFilter"></plugin-filter>
                </template>
            </template>
            <template v-else>
                <plugin-filter-placeholder
                    v-for="filter in 5"
                    :key="filter"></plugin-filter-placeholder>
            </template>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import PluginFilterPlaceholder from '@/components/PluginFilterPlaceholder.vue';
    import PluginFilter from '@/components/PluginFilter.vue';

    export default {
        name: 'Sidebar',

        data() {
            return {
                filters: null,
                filteredPlugins: null,
                filteredPluginsFilter: {
                    categories:		[],
                    technologies:	[],
                    creators: 		[],
                    rating: 		[],
                    downloads:		[]
                },
            }
        },

        components: {
            PluginFilterPlaceholder,
            PluginFilter,
        },

        methods: {
            toggleFilter(filter, filterby, isSelected){
                this.$store.dispatch('toggleFilter', {filter, filterby, isSelected})
            },
            
            filterVisible() {
                if(this.$store.state.mobileFilterVisible) {
                    return 'sidebar active';
                }
                return 'sidebar';
            }
        },
        
        created() {
            axios({
                method: 'post',
                    withCredentials: true,
                url: 'https://api.library.loxone.com/loadFilters',
                headers: {'Content-Type': 'multipart/form-data' },
            }).then(response => {

                if(window.location.search.length > 0) {
                    let entryArray = window.location.search.split('?')[1].split('&');
                    for (let i = 0; i < entryArray.length; i++) {
                        let entry = entryArray[i].split('=');
                        let subEntry = entry[1].split(',');
                        for (let e = 0; e < subEntry.length; e++) {
                            if(entry[0] === 't') {
                                response.data.technology.entries[subEntry[e]].selected = true;
                            }
                            if(entry[0] === 'c') {
                                response.data.category.entries[subEntry[e]].selected = true;
                            }
                            if(entry[0] === 'wwl') {
                                response.data.certified.entries[subEntry[e]].selected = true;
                            }
                            if(entry[0] === 'cr') {
                                response.data.creator.entries[subEntry[e]].selected = true;
                            }
                        }

                    }
                }


                this.$store.state.currentFilters = response.data

                if(location.hash == '#works-with-loxone') {
                    location.hash = '';
                    var filter = 1;
                    var filterby = 'certified';
                    var isSelected = false;
                    this.$store.dispatch('toggleFilter', {filter, filterby, isSelected});
                }
            });
        },
    }
</script>

<style lang="scss" scoped>
    @import '../scss/modules/sidebar';
</style>